import { styled } from 'styled-components';

export const StyledLayoutWrapper = styled.div`
  flex-grow: 1;
  position: relative;
`;
